import React from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts, moduleColors } from "../theme";
import { View, Text, Card, Press, ScreenHeader, IconTile, ProgressBar } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { useAppState } from "../state";
import { AREAS, lessonsByArea, t } from "../content";

export default function Learn() {
  const navigate = useNavigate();
  const { tr, lang } = useI18n();
  const { state } = useAppState();
  return (
    <View style={{ flex: 1, backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={tr("modules")} big />
      <View style={{ padding: 20, gap: 14 }}>
        {AREAS.map((area, idx) => {
          const lessons = lessonsByArea(area.id);
          const done = lessons.filter((l) => state.lessons[l.id]?.completed).length;
          const pct = lessons.length ? Math.round((done / lessons.length) * 100) : 0;
          const mc = moduleColors[idx];
          return (
            <Press key={area.id} testID={`module-${area.id}`} onClick={() => navigate(`/module/${area.id}`)}>
              <Card style={{ flexDirection: "row", gap: 14, alignItems: "center" }}>
                <IconTile icon={area.icon} tint={mc.tint} accent={mc.accent} />
                <View style={{ flex: 1, minWidth: 0 }}>
                  <Text style={{ fontWeight: fonts.bold, fontSize: 12, color: mc.accent, letterSpacing: 1 }}>{area.num}</Text>
                  <Text numberOfLines={1} style={{ fontWeight: fonts.bold, fontSize: 16, color: colors.onSurface, marginBottom: 2 }}>{t(area.title, lang)}</Text>
                  <Text numberOfLines={2} style={{ fontWeight: fonts.regular, fontSize: 12, color: colors.muted, marginBottom: 10 }}>{t(area.desc, lang)}</Text>
                  <View row style={{ alignItems: "center", gap: 10 }}>
                    <View style={{ flex: 1 }}><ProgressBar progress={pct} color={mc.accent} height={6} /></View>
                    <Text style={{ fontWeight: fonts.semibold, fontSize: 12, color: colors.muted }}>{done}/{lessons.length}</Text>
                  </View>
                </View>
                <Icon name="caret-right" size={18} color={colors.muted} />
              </Card>
            </Press>
          );
        })}
      </View>
    </View>
  );
}
